import WorksServices from '../xx-vue/services/works'
export default {
    namespaced: true,
    state: {
        page: 1,
        limit: 6,
        total: 0,
        worksList: []
    },
    mutations: {
        getWorksList: (state, payload) => {
            state.worksList = payload
            console.log(state.worksList);
        },
        changePage: (state, payload) => {
            state.page = payload
        },
        changeLimit: (state, payload) => {
            state.limit = payload
        },
        changeTotal: (state, payload) => {
            state.total = payload
        }
    },
    actions: {
        getWorksList: async ({ commit, state }) => {
            let result = await WorksServices.getMyWorksAsync({ page: state.page, limit: state.limit });
            commit('changeTotal', result.data.total)
            commit('getWorksList', result.data.data.opus)
        },
    },
    getters: {
        pages: state => {
            return Math.ceil(state.total / state.limit);
        }
    }
}